<template>
  <div :class="$options.name">
    <v-card :loading="isLoading" width="800px">
      <role-form
        v-model="form"
        :permissions-list="permissionsList"
        :regions-list="regionsList"
        :roles-list="rolesList"
        @submit="onCreate"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RoleForm from './components/RoleForm.vue';

export default {
  name: 'roles-create-view',
  asyncData({ store }) {
    const actions = [
      store.dispatch('permissions/searchSelect/getList'),
      store.dispatch('regions/searchSelect/getList'),
      store.dispatch('roles/searchSelect/getList'),
    ];

    return Promise.all(actions);
  },
  components: { RoleForm },
  data: () => ({
    form: null,
    isLoading: false,
  }),
  computed: {
    ...mapState('permissions/searchSelect', {
      permissionsList: 'list',
    }),
    ...mapState('regions/searchSelect', {
      regionsList: 'list',
    }),
    ...mapState('roles/searchSelect', {
      rolesList: 'list',
    }),
  },
  methods: {
    ...mapActions('roles', ['create']),
    ...mapActions(['showNotify']),

    async onCreate() {
      this.isLoading = true;

      try {
        const newRole = await this.create(this.form);
        this.showNotify({ message: 'Роль успешно создана' });
        this.$router.push({ name: 'roles-item', params: { id: newRole.id } });
      } catch (error) {
        const message = error.response?.data?.message || 'Ошибка при создании роли';
        this.showNotify({ type: 'error', message });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
